// extracted by mini-css-extract-plugin
export var standaloneTable = "_1k-0";
export var standaloneTableWithBodyFill = "_1k-1";
export var withExtraHeader = "_1k-2";